import gsap from "gsap";

(function ($) {
	$(document).ready(function () {
		// Month-Picker
		const monthPrev = $('.month-picker-nav--prev');
		const monthNext = $('.month-picker-nav--next');
		const pickerDate = $('.picker-date');
		// decrement month
		if (monthPrev.length) {
			monthPrev.click(function (e) {
				if (!monthPrev.hasClass('disabled')) {
					let prevMonth = parseInt(pickerDate.data('month')) - 1;
					let year = parseInt(pickerDate.data('year'));
					if(prevMonth === 0) {
						year = year - 1;
						prevMonth = 12;
					}
					pickerDate.data('month', prevMonth).data('year', year).text(getMonthName(prevMonth))
          clearURLHash();
					filterEvents();
				}
			})
		}
		// increment month
		if (monthNext.length) {
			monthNext.click(function (e) {
				if (!monthNext.hasClass('disabled')) {
					let nextMonth = parseInt(pickerDate.data('month')) + 1;
					let year = parseInt(pickerDate.data('year'));
					if(nextMonth === 13) {
						year = year + 1;
						nextMonth = 1;
					}
					pickerDate.data('month', nextMonth).data('year', year).text(getMonthName(nextMonth))
          clearURLHash();
					filterEvents();
				}
			})
		}
		// Term Filter
		const filters = $('.archive-type-indy_event__topbar__filter .indy-badge');
		const style = getComputedStyle(document.body);
		const currentWrapper = $('.current-cat');

		let filter_terms = [];
		if (filters.length) {
			filters.click(function () {
					filters.removeClass('is-active')
					$(this).addClass('is-active')
					if ($(this).data('term') != 'all') {
						filter_terms = [];
						filter_terms.push(String($(this).data('term')));
						currentWrapper.html($(this).html());
						hideFilterModal();
					}
					else {
						filter_terms = [];
						currentWrapper.html('Alle');
						hideFilterModal();
					}
          clearURLHash();
				  filterEvents();
				})
		}
		// filters events with date & terms
		function filterEvents() {
			const teasers = $('.indy_event-tease');
			let hasVisibleEvent = false;

			const allMonths = $('.indy_event-tease').map(function () {
				const monthsData = $(this).attr('data-months') || $(this).attr('data-month') || '';
				return monthsData.split(',').map(m => parseInt(m.trim())).filter(m => !isNaN(m));}).get().flat();

			const uniqueMonths = [...new Set(allMonths)].sort((a, b) => a - b);

			const filterMonth = parseInt(pickerDate.data('month'));
			const filterYear = parseInt(pickerDate.data('year'));

			teasers.each(function () {
				const terms = String($(this).data('terms') || '');
				const term_ids = terms ? terms.split(', ') : [];

				const monthsData = $(this).attr('data-months') || $(this).attr('data-month') || '';
				const teaserMonths = monthsData.split(',').map(m => parseInt(m.trim())).filter(m => !isNaN(m));
				const monthMatch = teaserMonths.includes(filterMonth);
				const teaserYear = parseInt($(this).data('year')) || filterYear;
				const hideEventTerms = String($(this).data('hide-event-terms') || '');
				const hideEventTermIds = hideEventTerms ? hideEventTerms.split(', ') : [];

				const showEvent =
					(term_ids.some(ai => filter_terms.includes(ai)) && monthMatch) ||
					(hideEventTermIds.length === 0 && filter_terms.length === 0 && monthMatch);

				if (showEvent) {
					hasVisibleEvent = true;
					gsap.to(this, 0.2, {
						height: "auto",
						borderColor: style.getPropertyValue('--indy-tertiary'),
						paddingTop: '1rem',
						paddingBottom: '1rem',
						overflow: 'visible'
					});
				} else {
					gsap.to(this, 0.2, {
						height: 0,
						borderColor: 'transparent',
						padding: 0,
						overflow: 'hidden'
					});
				}
			});

			if (!hasVisibleEvent) {
				const currentMonth = filterMonth;
				const nextMonth = uniqueMonths.find(m => m > currentMonth);
				const prevMonth = [...uniqueMonths].reverse().find(m => m < currentMonth);

				if (nextMonth) {
					pickerDate.data('month', nextMonth).text(getMonthName(nextMonth));
					filterEvents();
					return;
				} else if (prevMonth) {
					pickerDate.data('month', prevMonth).text(getMonthName(prevMonth));
					filterEvents();
					return;
				}
			}

			disableButtons(uniqueMonths);

			setTimeout(() => {
				scrollToEventFromHash();
			}, 300);
		}

    function scrollToEventFromHash() {
      const hash = window.location.hash; // Get the #id from URL
      if (hash) {
          const targetElement = $(hash);
          if (targetElement.length) {
              $('html, body').animate({ scrollTop: targetElement.offset().top - 200 }, 1000);
          }
      }
    }

    function clearURLHash() {
      if (window.history.replaceState) {
          window.history.replaceState(null, null, window.location.pathname + window.location.search);
      }
    }

		// Helper Functions
		// check if same month & year
		function checkDate(m1, m2, y1, y2) {
			return m1 == m2 && y1 == y2;
		}
		// self-explanatory
		function getMonthName(monthNumber) {
			if (!monthNumber || isNaN(monthNumber) || monthNumber < 1 || monthNumber > 12) {
				const now = new Date();
				return now.toLocaleString('de-CH', { month: 'long' });
			}
			const date = new Date(2000, monthNumber - 1);
			return date.toLocaleString('de-CH', { month: 'long' });
		}
		// skips to month of first teaser item
		function initializeFilter() {
			const urlParams = new URLSearchParams(window.location.search);
			let eventMonth = parseInt(urlParams.get("event_month"));
			let eventYear = parseInt(urlParams.get("event_year"));

			const firstTeaserItem = $('.indy_event-tease').first();

			if (!isNaN(eventMonth) && eventMonth >= 1 && eventMonth <= 12 && !isNaN(eventYear)) {
				pickerDate
					.data('month', eventMonth)
					.data('year', eventYear)
					.text(getMonthName(eventMonth));
			}
			else if (firstTeaserItem.length) {
				const firstTeaserMonth = parseInt(firstTeaserItem.data('month')) || (new Date().getMonth() + 1);
				const firstTeaserYear = parseInt(firstTeaserItem.data('year')) || new Date().getFullYear();

				pickerDate
					.data('month', firstTeaserMonth)
					.data('year', firstTeaserYear)
					.text(getMonthName(firstTeaserMonth));
			}
			else {
				const now = new Date();
				pickerDate
					.data('month', now.getMonth() + 1)
					.data('year', now.getFullYear())
					.text(getMonthName(now.getMonth() + 1));
			}

			filterEvents();
		}

		function disableButtons() {
			const teasers = $('.indy_event-tease');

			const allDates = [];

			teasers.each(function () {
				const monthsData = $(this).attr('data-months') || $(this).attr('data-month') || '';
				const year = parseInt($(this).data('year'));
				if (isNaN(year)) return;

				monthsData.split(',').forEach(m => {
					const month = parseInt(m.trim());
					if (!isNaN(month)) {
						allDates.push({ month, year });
					}
				});
			});

			if (allDates.length === 0) {
				monthPrev.addClass('disabled');
				monthNext.addClass('disabled');
				return;
			}

			const uniqueDates = allDates.filter(
				(v, i, a) => a.findIndex(t => t.month === v.month && t.year === v.year) === i
			);
			uniqueDates.sort((a, b) => a.year === b.year ? a.month - b.month : a.year - b.year);

			const currentMonth = parseInt(pickerDate.data('month'));
			const currentYear = parseInt(pickerDate.data('year'));
			const firstDate = uniqueDates[0];
			const lastDate = uniqueDates[uniqueDates.length - 1];

			if (currentYear < firstDate.year || (currentYear === firstDate.year && currentMonth <= firstDate.month)) {
				monthPrev.addClass('disabled');
			} else {
				monthPrev.removeClass('disabled');
			}

			if (currentYear > lastDate.year || (currentYear === lastDate.year && currentMonth >= lastDate.month)) {
				monthNext.addClass('disabled');
			} else {
				monthNext.removeClass('disabled');
			}
		}

		initializeFilter();

	});

	$('.archive-type-indy_event__topbar__filter__current').click(function () {
		$('.archive-type-indy_event__topbar__filter__list').addClass('is-active');
	});

	$('.archive-type-indy_event__topbar__filter__list__close').click(function () {
		hideFilterModal();
	});

	function hideFilterModal()  {
		$('.archive-type-indy_event__topbar__filter__list').removeClass('is-active');
	}
})(jQuery);

